import { render, staticRenderFns } from "./traceCodelModel.vue?vue&type=template&id=0b1c5c2e&scoped=true"
import script from "./traceCodelModel.vue?vue&type=script&lang=js"
export * from "./traceCodelModel.vue?vue&type=script&lang=js"
import style0 from "./traceCodelModel.vue?vue&type=style&index=0&id=0b1c5c2e&prod&scoped=true&lang=css"
import style1 from "./traceCodelModel.vue?vue&type=style&index=1&id=0b1c5c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c5c2e",
  null
  
)

export default component.exports